<template>
    <svg class="icon icon-chart" @click="getMeal">
        <use xlink:href="#icon-chart"></use>
    </svg>
</template>

<script>
import axios from 'axios';
import state from './../state.js';

export default {
    props: ['id', 'title'],

    data() {
        return {
            state
        };
    },

    methods: {
        getMeal(id) {
            axios
                .get('/recept/api/menu/meal/' + this.id)
                .then((response) => {
                    this.state.charts = response.data;
                    this.state.chartHeader.title = this.title;
                })
                .catch((error) => {});
        }
    }
};
</script>
